import monash_logo from "../images/Monash_2U_logo.jpg";
import accenture_logo from "../images/accenture_logo.jpg";
import sam_mainwood from "../images/sam_mainwood.jpg";
import juwon_lee from "../images/juwon_lee.jpg";
import sam_blackburn from "../images/sam_blackburn.jpg";
import rmit_logo from "../images/rmit_university_logo.jpg";
import sist_logo from "../images/sathyabama_institute_of_science__technology_chennai_logo.jpg";
import sjps_logo from "../images/sjps_logo.jpg";
import anz_logo from "../images/anz_logo.jpg";
import r_logo from "../images/Rlogo.png";
import EmotiScanPreview from "../images/EmotiScanPreview.png"
import roshanthaliath from "../images/roshanthaliath.jpg"
import giri from "../images/giri.jpg"
import irfannekakhtar from "../images/irfannekakhtar.jpg"

export const Bio = {
  name: "Chris John",
  roles: [
    "Data Scientist",
    "ML Engineer",
    "Data Analyst",
    "Programmer",
  ],
  description: "As an enthusiast in the realm of data science, machine learning, and computer vision, I enjoy playing with \
  data and teaching computers to see and learn things better. I'm on a journey of learning new things, so I can bring\
  cool ideas to the world of technology.",
  github: "https://github.com/Git-With-Chris",
  resume: "https://www.linkedin.com/in/chrisjohn11/",
  linkedin: "https://www.linkedin.com/in/chrisjohn11/",
};

export const skills = [
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Pandas",
        image:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pandas/pandas-original.svg",
      },
      {
        name: "TensorFlow",
        image: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg",
      },
      {
        name: "Numpy",
        image:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/numpy/numpy-original.svg",
      },
      {
        name: "Keras",
        image:
        "https://raw.githubusercontent.com/valohai/ml-logos/master/keras.svg",
      },
      {
        name: "Scikit-learn",
        image:
        "https://raw.githubusercontent.com/valohai/ml-logos/master/scipy.svg",
      },
      {
        name: "HuggingFace",
        image:
        "https://huggingface.co/datasets/huggingface/brand-assets/resolve/main/hf-logo.svg",
      },
      {
        name: "NLTK",
        image:
        "https://miro.medium.com/v2/resize:fit:592/1*YM2HXc7f4v02pZBEO8h-qw.png",
      },
    ],
  },
  {
    title: "Programming",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "R",
        image:
          r_logo,
      },
      {
        name: "MySQL",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "Java",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-plain.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "Vim",
        image:
          "https://cdn.simpleicons.org/vim/019733",
      },
      {
        name: "Jupyter",
        image:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jupyter/jupyter-original.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/1024px-Git_icon.svg.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Linux",
        image:
          "https://cdn.simpleicons.org/linux/FCC624"
      },
      {
        name: "Slack",
        image:
        "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/slack/slack-original.svg"
      },
      {
        name: "Tableau",
        image:
        "https://img.icons8.com/?size=100&id=9Kvi1p1F0tUo&format=png&color=000000"
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: anz_logo,
    role: "Machine Learning Student Consultant",
    company: "ANZ Banking Group",
    date: "Mar 2024 - Jun 2024",
    desc: "As part of RMIT University's Industry project, I collaborated with ANZ's Client Insights Team to \
    optimize reporting processes for over 8 million clients across 30 industries. My contributions included \
    designing an AI-powered solution to quickly retrieve relevant sentences from ESG reports, reducing processing \
    time by 40%. Additionally, I developed an easy-to-use UI with Python and Flask API, significantly enhancing user \
    satisfaction from an estimated 4/10 to 7/10. Throughout the project, I effectively managed relationships with over \
    three stakeholders, including the Director of Industry & Innovation.",
    skills: [
      "Python",
      "Machine Learaning", 
      "TensorFlow",
      "HuggingFace API", 
      "Flask",
      "Data Analysis",
      "Git"
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 1,
    img: monash_logo,
    role: "Teaching Assistant",
    company: "Monash University",
    date: "May 2023 - November 2023",
    desc: "As a Tutor, I played a crucial role in supporting students by providing assistance with their \
    coursework and assignments. This involved guiding them through complex concepts, offering clarifications\
    and helping them develop effective strategies for completing their tasks. Provided tailored approach to meet\
    individual learning styles and needs, fostering an environment that encouraged academic growth and success.",
    skills: [
      "Python",
      "SQL",
      "Flask",
      "MongoDB",
      "Spark",
      "Tableau",
      "Git",
      "Machine Learaning",
      "Neural Networks",
      "Beautiful Soup"
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 2,
    img: accenture_logo,
    role: "Software Engineer Intern",
    company: "Accenture",
    date: "Jan 2022 - Jun 2022",
    desc: "As an Associate Software Engineer Intern, I successfully completed a rigorous 4-month training program focused \
    on big data technologies featuring Hadoop and Spark.\
    Demonstrated expertise in delivering client support for system operation and excelled in troubleshooting, ensuring seamless\
    operational functionality.",
    skills: [
      "Java",
      "Spark",
      "Hadoop",
      "SQL",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/WhatsApp%20Image%202023-05-05%20at%2012.07.39%20AM.jpeg?alt=media&token=9f0e1648-568b-422d-bd0b-1f125f722245",
  },
];

export const education = [
  {
    id: 0,
    img: rmit_logo,
    school: "RMIT University, Australia",
    date: "Jun 2022 - Aug 2024",
    desc: "Acquired advanced expertise in Statistical Modelling, Machine Learning Modelling, and Data Wrangling, \
    enabling me to evaluate complex data collections and solve problems using data analysis. Demonstrated a strong \
    track record in deep learning, with a focus on computer vision projects.",
    degree: "Master of Data Science",
  },
  {
    id: 1,
    img: sist_logo,
    school: "Sathyabama University, India",
    date: "Jul 2017 - Sep 2021",
    desc: " Developed proficiency in key programming languages, including Python, Java, SQL, and C, and fluency in \
    multiple programming paradigms, such as Object-Oriented and Functional programming. Executed a final project that \
    challenged my technical skills and problem-solving abilities",
    degree: "Bachelor of Technology - Computer Science and Engineering",
  },
  {
    id: 2,
    img: sjps_logo,
    school: "St.John's Public School, India",
    date: "Jun 2013 - May 2017",
    desc: "I had the honor of serving as the Head Boy for two consecutive years, from 2016, where I was responsible for \
    leading and representing the student body. Acquired expertise in Advanced Mathematics, Physics and Chemistry",
    degree: "High School",
  },
];

export const projects = [
  {
    id: 0,
    title: "Emoti Scan",
    date: "Mar 2023 - Apr 2023",
    description:
      "EmotiScan brings the magic of machine learning to recognize emotions and expressions in pictures. With EmotiScan, you can upload an image and receive predictions about the emotions and facial action units displayed in the photo. It's an enjoyable way to explore the subtleties of facial expressions and understand the underlying emotions.",
    image: EmotiScanPreview,
    tags: ["Tensorflow", "Keras", "Scikit-learn", "CNN", "Multi-Task Classification", "Streamlit"],
    category: "machine learning",
    github: "https://github.com/Git-With-Chris/EmotiScan",
    member: [
      {
        name: "Chris John",
        img: "https://avatars.githubusercontent.com/u/132337461?v=4",
        linkedin: "https://www.linkedin.com/in/chrisjohn11/",
        github: "https://github.com/Git-With-Chris",
      },
    ],
  },
  {
    id: 1,
    title: "Query PDF",
    date: "Mar 2024 - Jun 2024",
    description:
      "QueryPDF is a web application designed to enhance document analysis by intelligently retrieving relevant sentences based on user queries. Traditional search methods often miss nuanced information in documents, requiring exact keyword matches. QueryPDF overcomes this limitation using advanced sentence transformer models to identify contextually relevant sentences, even when specific keywords are absent.",
    image: "https://github.com/Git-With-Chris/QueryPDF/blob/main/Images/Preview.png?raw=true",
    tags: ["NLTK", "PyTorch", "Scikit-learn", "Sentence Transformer", "Hugging Face"],
    category: "machine learning",
    github: "https://github.com/Git-With-Chris/QueryPDF",
    member: [
      {
        name: "Chris John",
        img: "https://avatars.githubusercontent.com/u/132337461?v=4",
        linkedin: "https://www.linkedin.com/in/chrisjohn11/",
        github: "https://github.com/Git-With-Chris",
      },
      {
        name: "Krishnakanth Srikanth",
        img: giri,
        linkedin: "https://www.linkedin.com/in/krishnakanth-srikanth-2a3a36116/",
        github: "https://github.com/KrishnakanthSrikanth",
      },
      {
        name: "Roshan Thaliath",
        img: roshanthaliath,
        linkedin: "https://www.linkedin.com/in/roshan-thaliath/",
        github: "https://github.com/rthaliath",
      },
      {
        name: "Irfan Nekakhtar",
        img: irfannekakhtar,
        linkedin: "https://www.linkedin.com/in/irfannekakhtar/",
        github: "https://github.com/IrfanNe",
      },
    ],
  },
  {
    id: 2,
    title: "Feather Pal",
    date: "Jan 2023 - Jan 2023",
    description:
      "This project focuses on building a robust deep learning model for bird species \
      classification using TensorFlow and the EfficientNetB0 architecture. The dataset \
      consists of a diverse collection of bird images, and the goal is to train a model \
      that accurately identifies and classifies different bird species.",
    image:
      "https://github.com/Git-With-Chris/FeatherPal/raw/main/images/GradCAM.png",
    tags: ["Tensorflow", "Keras", "Scikit-learn", "Neural Network", "Transfer Learning"],
    category: "machine learning",
    github: "https://github.com/Git-With-Chris/FeatherPal",
    member: [
      {
        name: "Chris John",
        img: "https://avatars.githubusercontent.com/u/132337461?v=4",
        linkedin: "https://www.linkedin.com/in/chrisjohn11/",
        github: "https://github.com/Git-With-Chris",
      },
    ],
  }, 
  {
    id: 3,
    title: "HELOC Loan Tool",
    date: "Sept 2023 - Oct 2023",
    description:
      "Our primary objective was to leverage data-driven techniques to enhance the explainability of machine learning \
      models in the context of finance. We focused on creating a prediction model to evaluate risk and adapted it to \
      provide not only binary predictions but also a general confidence level, offering valuable insights for financial \
      decision-makers.",
    image:
      "https://github.com/WorkstationChris/WIL_Project/blob/main/webpage_samples/LandingPagePreData.png?raw=true",
    tags: ["Pandas", "Numpy", "Neural Network", "Python", "Dash", "Flask", "HTML", "CSS"],
    category: "machine learning",
    github: "https://github.com/Git-With-Chris/RiskPredict",
    member: [
      {
        name: "Chris John",
        img: "https://avatars.githubusercontent.com/u/132337461?v=4",
        linkedin: "https://www.linkedin.com/in/chrisjohn11/",
        github: "https://github.com/Git-With-Chris",
      },
      {
        name: "Sam Mainwood",
        img: sam_mainwood,
        linkedin: "https://www.linkedin.com/in/sammainwood/",
        github: "https://github.com/Mainies",
      },
      {
        name: "Sam Blackburn",
        img: sam_blackburn,
        linkedin: "https://www.linkedin.com/in/sam-blackburn-006b75276/",
        github: "https://github.com/sam-blackburn",
      },
      {
        name: "John Lee",
        img: juwon_lee,
        linkedin: "https://www.linkedin.com/in/john-lee-26b03b238/",
        github: "https://github.com/Data-JohnLee",
      },
    ],
  },
  {
    id: 4,
    title: "Death Rate Explorer",
    date: "Apr 2023 - Apr 2023",
    description:
      "The Death Rate Tracker (2019) Shiny App is an interactive data visualization tool built using Shiny, Leaflet, \
      Plotly, and other R packages. It allows users to explore and analyze death rates across different countries, age \
      groups, and causes of death for the year 2019.",
    image:
      "https://github.com/Git-With-Chris/DeathRateExplorer/raw/main/images/Demo.png",
    tags: ["Data Analysis", "R", "RShiny", "GGPlot", "Leaflet", "Plotly"],
    category: "analysis",
    github: "https://github.com/Git-With-Chris/DeathRateExplorer",
    member: [
      {
        name: "Chris John",
        img: "https://avatars.githubusercontent.com/u/132337461?v=4",
        linkedin: "https://www.linkedin.com/in/chrisjohn11/",
        github: "https://github.com/Git-With-Chris",
      },
    ],
  },
  {
    id: 5,
    title: "Global Plastic Pulse",
    date: "Mar 2023 - Apr 2023",
    description:
      "This project visualizes the global connection between plastic waste and Gross Domestic Product (GDP), \
      aiming to raise awareness among governments, waste management officials, and the public. This project \
      originated from the inspiration of a visualization found on Behance. \
      While recognizing the original visualization's merit, I identified some areas for improvement to better \
      align with the visualisation's objective.",
    image:
      "https://github.com/Git-With-Chris/GlobalPlasticPulse/raw/main/images/ReconstructedVisual.png",
    tags: ["Data Analysis", "R", "RShiny", "GGPlot", "Leaflet", "Plotly"],
    category: "analysis",
    github: "https://github.com/Git-With-Chris/GlobalPlasticPulse",
    member: [
      {
        name: "Chris John",
        img: "https://avatars.githubusercontent.com/u/132337461?v=4",
        linkedin: "https://www.linkedin.com/in/chrisjohn11/",
        github: "https://github.com/Git-With-Chris",
      },
    ],
  }
];